// export const ApiUrl = 'http://localhost:5000/api/v1';
export const ApiUrl = 'https://simplyenglish.ai:5000/api/v1';